/* Mailchimp's "OUR NEWSLETTER" tab is position:fixed at bottom:10px, inside an open shadow root.
   Event pages have a sticky bar on that same edge. Lift only the tab so it sits just above the bar. */
(function () {
  var GAP = 10;
  var LABEL = /^\s*(?:×|✕|x)?\s*OUR NEWSLETTER\s*$/i;

  function stickyBar() {
    return document.querySelector('.sacbe-muertos-sticky, .sacbe-sched__sticky');
  }

  function stickyHeight() {
    var bar = stickyBar();
    if (!bar) return 0;
    var cs = getComputedStyle(bar);
    if (cs.display === 'none' || cs.visibility === 'hidden' || bar.hasAttribute('hidden')) return 0;
    var rect = bar.getBoundingClientRect();
    if (rect.height < 1 || rect.bottom < window.innerHeight - 4) return 0;
    return Math.ceil(rect.height);
  }

  function isCornerTab(el) {
    var cs = getComputedStyle(el);
    if (cs.position !== 'fixed' || cs.bottom === 'auto') return false;
    var left = parseFloat(cs.left);
    if (!(left >= 0 && left <= 48)) return false;
    if ((cs.width || '').indexOf('%') !== -1) return false;
    if ((cs.height || '').indexOf('%') !== -1) return false;
    return true;
  }

  function teaserOf(node, root) {
    var el = node;
    while (el && el !== root) {
      if (isCornerTab(el)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function liftHost(host) {
    var root = host.shadowRoot;
    if (!root) return;
    var bottom = stickyHeight() > 0 ? stickyHeight() + GAP + 'px' : '10px';
    var nodes = root.querySelectorAll('div, button, a, span');
    for (var i = 0; i < nodes.length; i++) {
      var text = (nodes[i].textContent || '').replace(/\s+/g, ' ');
      if (!LABEL.test(text)) continue;
      var teaser = teaserOf(nodes[i], root);
      if (!teaser) continue;
      if (teaser.style.getPropertyValue('bottom') !== bottom) {
        teaser.style.setProperty('bottom', bottom, 'important');
      }
    }
  }

  function lift() {
    var hosts = document.querySelectorAll('.mcforms-wrapper');
    for (var i = 0; i < hosts.length; i++) liftHost(hosts[i]);
  }

  function watchHost(host) {
    if (host.dataset.sacbeNlWatch) return;
    host.dataset.sacbeNlWatch = '1';
    liftHost(host);
    if (!host.shadowRoot) return;
    new MutationObserver(function () {
      liftHost(host);
    }).observe(host.shadowRoot, { childList: true, subtree: true });
  }

  function scan() {
    var hosts = document.querySelectorAll('.mcforms-wrapper');
    for (var i = 0; i < hosts.length; i++) watchHost(hosts[i]);
    lift();
  }

  function boot() {
    scan();
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('resize', lift);
    var bar = stickyBar();
    if (bar && window.ResizeObserver) new ResizeObserver(lift).observe(bar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
